import React from 'react';
import SeatingChart from '../components/SeatingChart/SeatingChart';
import PeopleTable from '../components/PeopleTable/PeopleTable';
import './SeatingChartPage.css';

const generatePeople = () => {
  const people = [
    {
      name: "Amber Gebka",
      tableId: 5,
      seatNumber: 1
    },
    {
      name: "Bart Gebka",
      tableId: 5,
      seatNumber: 2,
    },
    {
      name: "Kolya Isterabadi",
      tableId: 5,
      seatNumber: 3,
    },
    {
      name: "Alex Moran",
      tableId: 5,
      seatNumber: 4,
    },
    {
      name: "Alana Luebke",
      tableId: 5,
      seatNumber: 5,
    },
    {
      name: "Riley Wright",
      tableId: 5,
      seatNumber: 6,
    },
    {
      name: "Sarah Conner",
      tableId: 5,
      seatNumber: 7
    },
    {
      name: "James Conner",
      tableId: 5,
      seatNumber: 8
    },
    {
      name: "Michael Conner",
      tableId: 5,
      seatNumber: 9
    },
    {
      name: "Ashlynn Micoliczyk",
      tableId: 5,
      seatNumber: 10
    },
    {
      name: "Amber Micoliczyk",
      tableId: 5,
      seatNumber: 11
    },
    {
      name: "Yeji Shin",
      tableId: 5,
      seatNumber: 12
    },
    {
      name: "Luke Harwood",
      tableId: 4,
      seatNumber: 1
    },
    {
      name: "Gabby Harwood",
      tableId: 4,
      seatNumber: 2
    },
    {
      name: "Abby Hillner",
      tableId: 4,
      seatNumber: 3
    },
    {
      name: "Ann Young",
      tableId: 4,
      seatNumber: 4
    },
    {
      name: "Joe Young",
      tableId: 4,
      seatNumber: 5
    },
    {
      name: "Mike Adams",
      tableId: 4,
      seatNumber: 6
    },
    {
      name: "Jim Conner",
      tableId: 4,
      seatNumber: 7
    },
    {
      name: "Danielle Conner",
      tableId: 4,
      seatNumber: 8
    },
    {
      name: "Kevin Quint",
      tableId: 3,
      seatNumber: 1
    },
    {
      name: "Heather Quint",
      tableId: 3,
      seatNumber: 2
    },
    {
      name: "Kolton Micoliczyk",
      tableId: 3,
      seatNumber: 3
    },
    {
      name: "Mark Micoliczyk",
      tableId: 3,
      seatNumber: 4
    },
    {
      name: "Karen Micoliczyk",
      tableId: 3,
      seatNumber: 5
    },
    {
      name: "Sue Browne",
      tableId: 3,
      seatNumber: 6
    },
    {
      name: "Ken Browne",
      tableId: 3,
      seatNumber: 7
    },
    {
      name: "Autumn Beyer",
      tableId: 2,
      seatNumber: 1
    },
    {
      name: "Mitchell Johnstone",
      tableId: 2,
      seatNumber: 2
    },
    {
      name: "Sam Keyser",
      tableId: 2,
      seatNumber: 3
    },
    {
      name: "Ryan Kruk",
      tableId: 2,
      seatNumber: 4
    },
    {
      name: "Justin Benning",
      tableId: 2,
      seatNumber: 5
    },
    {
      name: "Jonny Keane",
      tableId: 2,
      seatNumber: 6
    },
    {
      name: "Nikhil Gajghate",
      tableId: 2,
      seatNumber: 7
    },
    {
      name: "Mary Jane Cramer",
      tableId: 2,
      seatNumber: 8
    },
    {
      name: "Jordan Green",
      tableId: 1,
      seatNumber: 1
    },
    {
      name: "Caroline Bank",
      tableId: 1,
      seatNumber: 2
    },
    {
      name: "Mak Monastyrskyy",
      tableId: 1,
      seatNumber: 3
    },
    {
      name: "Aiden Prud'Homme",
      tableId: 1,
      seatNumber: 4
    },
    {
      name: "Kevin Standlee",
      tableId: 1,
      seatNumber: 5
    },
    {
      name: "Michelle Standlee",
      tableId: 1,
      seatNumber: 6
    },
    {
      name: "Brie Standlee",
      tableId: 1,
      seatNumber: 7
    },
    {
      name: "Faith Standlee",
      tableId: 1,
      seatNumber: 8
    }
  ];
  return people;
};

const SeatingChartPage: React.FC = () => {
  const people = generatePeople();

  return (
    <main className="page seating-chart-page">
      <div className="page-header">
        <h1>Seating Chart</h1>
        <p>Find your seat and get ready to celebrate!</p>
      </div>

      <div className="seating-content">
        <div className="people-section">
          <PeopleTable people={people} />
        </div>

        <div className="chart-section">
          <SeatingChart people={people} />
        </div>
      </div>
    </main>
  );
};

export default SeatingChartPage;
